import CountryFlag from "plos/src/components/CountryFlag";
import { usePlosTranslations } from "plos/src/contexts/PlosTranslationsContext";
import {
  entryInfo,
  entryName,
  playerInfo,
  playerName,
} from "./playerInfoPanel.css";
import { PlayerInfoPanelProps } from "./types";

const PlayerInfoPanel = ({ region, entry, player }: PlayerInfoPanelProps) => {
  const { teamName } = usePlosTranslations();
  const playerInfoEntryName = entry?.name || teamName;

  return (
    <div className={entryInfo}>
      <h3 className={entryName}>{playerInfoEntryName}</h3>

      <div className={playerInfo}>
        {region && <CountryFlag region={region} />}
        <span className={playerName}>
          {player.first_name} {player.last_name}
        </span>
      </div>
    </div>
  );
};
export default PlayerInfoPanel;
